export const SET_FACTORY_DATA_STORE = "SET_FACTORY_DATA_STORE";

export const setFactoryDataStore = (payload) => ({
  type: SET_FACTORY_DATA_STORE,
  payload,
});
